import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import AlertIcon from "@mui/icons-material/Warning";
import IconButton from "@mui/material/IconButton";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import loader from "../../Images/ajax-loader.gif";
import { ToastContainer, toast } from "react-toastify";
import {
  add_new_committe_member,
  get_committee_members_data,
  disableCommitteMember,
  deleteCommitteMember,
  updateCommitteTable,
  show_committee_names,
  show_sustanaible_goals
} from "../../api/User";
import "../Admin/table.css"
const CommitteeMembersDetails = ({ committeName, memberType }) => {
  const [errors, setErrors] = useState({});
  const userId = sessionStorage.getItem("user_id");
  const role_id = sessionStorage.getItem("role_id");
  const gpID = sessionStorage.getItem("gp_data") || "";
  const [formData, setFormData] = useState({
    id: userId,
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });
  const [formErrors, setFormErrors] = useState({
    id: userId,
    committee_type: "",
    member_type: "",
    member_name: "",
    mobile_no: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");
  const [committeeNames, setcommitteeNames] = useState([]);
  const [sustanaibleGoals, setsustanaibleGoals] = useState([]);
  const [othersInput, setOthersInput] = useState(false);
  const [memberTypeState, setMemberTypeState] = useState(memberType || []);
  const [openDialog, setOpenDialog] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [editData, setEditData] = useState(null);
  const [MemberTypeErr, setMemberTypeErr] = useState("");
  const [validateFormData, setvalidateFormData] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const fetchData = async () => {
    const data = {
      id: userId,
    };
    try {
      const res = await get_committee_members_data(token, data);
      if (res.status === "success") {
        setFilteredData(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.", { autoClose: 1000 });
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const fetchCommitteeNames = async () => {
      try {
        const res = await show_committee_names(token);
        if (res.status === "success") {
          setcommitteeNames(res.data);
        } else {
          toast.error(res.message, { autoClose: 1000 });
        }
      } catch (error) {
        console.error("Error fetching committee names:", error);
        toast.error("An error occurred while fetching committee names.", { autoClose: 1000 });
      }
    };
    fetchCommitteeNames();
  }, [token]);
  const fetchcommitteeid = async (committee_id) => {
    try {
      const res = await show_sustanaible_goals(token, committee_id);
      if (res.status === "success") {
        setsustanaibleGoals(res.data);
      } else {
        toast.error(res.message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching blocks:", error);
      toast.error("An error occurred while fetching blocks.", { autoClose: 1000 });
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const committeeTypeError = formData.committee_type ? "" : "Committee Name is required.";
    const memberTypeError = formData.member_type ? "" : "Sustainable Goal is required.";
    const newFormErrors = {
      id: formData.id,
      committee_type: committeeTypeError,
      member_type: memberTypeError,
      member_name: "",
      mobile_no: "",
    };
    setFormErrors(newFormErrors);
    if (formData.committee_type && formData.member_type) {
      try {
        const members = tableData.map(item => ({
          id: formData.id,
          member_name: item.member_name,
          mobile_no: item.mobile_no,
          member_type: item.member_type_id,
          committee_type: item.committee_type_id,
        }));
        if (members.length === 0) {
          toast.error("At least one member is required.");
          return;
        }
        const submissionData = {
          committees: members,
        };
        console.log("Submitting data:", submissionData);
        const res = await add_new_committe_member(token, submissionData);
        if (res.status === "success") {
          toast.success(res.message);
          fetchData();
          handleReset();
          setOthersInput(false);
          setShowTable(false);
          setTableData([]);
        } else {
          toast.error(res.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("An error occurred while submitting the form.");
      }
    } else {
      setFormErrors(newFormErrors);
    }
  };
  const handleAdd = () => {
    const memberNameError = formData.member_name ? "" : "Member Name is required.";
    const mobileNoError = formData.mobile_no ? "" : "Mobile No is required.";
    const committeeTypeError = formData.committee_type_name ? "" : "Committees Name is required.";
    const memberTypeError = formData.member_type_display ? "" : "Sustainable Goal is required.";
    if (memberNameError || mobileNoError || committeeTypeError || memberTypeError) {
      setFormErrors({
        member_name: memberNameError,
        mobile_no: mobileNoError,
        committee_type: committeeTypeError,
        member_type: memberTypeError,
      });
      return;
    }
    const newMember = {
      committee_type: formData.committee_type_name,
      member_type: formData.member_type_display,
      member_name: formData.member_name,
      mobile_no: formData.mobile_no,
      committee_type_id: formData.committee_type,
      member_type_id: formData.member_type,
    };
    setTableData(prevTableData => [...prevTableData, newMember]);
    setFormData(prevFormData => ({
      ...prevFormData,
      member_name: "",
      mobile_no: "",
    }));
    setFormErrors({});
    setShowTable(true);
    toast.success("Records added successfully!", { autoClose: 1000 });
  };
  const handleDelete_New = (index) => {
    const updatedTableData = tableData.filter((_, i) => i !== index);
    setTableData(updatedTableData);
  };
  const handleEditSubmit = async (event) => {
    event.preventDefault();
    const errors = {
      committee_type: editData.committee_type ? "" : "Committee Name is required.",
      member_type: editData.member_type ? "" : "Sustainable Goal is required.",
      member_name: editData.member_name ? "" : "Member Name is required.",
      mobile_no: validateMobileNo(editData.mobile_no),
    };
    setErrors(errors);
    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (hasErrors) {
      return;
    }
    try {
      const res = await updateCommitteTable(token, editData);
      if (res.status === "success") {
        toast.success(res.message);
        fetchData();
        setOpenEditModal(false);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error("Error updating record:", error);
      toast.error("An error occurred while updating the record.");
    }
  };
  const validateMobileNo = (mobile_no) => {
    if (!mobile_no) return "Mobile Number is required.";
    if (!/^\d{10}$/.test(mobile_no)) return "Mobile Number must be exactly 10 digits.";
    if (mobile_no[0] === '0') return "Mobile Number cannot start with zero.";
    if (/^0{10}$/.test(mobile_no)) return "Mobile Number cannot be all zeros.";
    return "";
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "mobile_no") {
      const numericValue = value.replace(/\D/g, '').slice(0, 10);
      if (numericValue.startsWith("0")) {
        setFormErrors((prevState) => ({
          ...prevState,
          [name]: "Mobile number cannot start with 0.",
        }));
      } else {
        setFormData((prevState) => ({
          ...prevState,
          [name]: numericValue,
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          [name]: validateMobileNo(numericValue),
        }));
      }
    }
    else if (name === "member_name") {
      const uppercaseValue = value.toUpperCase();
      const cleanedValue = uppercaseValue.replace(/[^A-Z\s]/g, '');
      const trimmedValue = cleanedValue.replace(/^\s+/, '');
      setFormData((prevState) => ({
        ...prevState,
        [name]: trimmedValue,
      }));
      if (!trimmedValue.trim()) {
        setFormErrors((prevState) => ({
          ...prevState,
          member_name: "Member Name is required.",
        }));
      } else {
        setFormErrors((prevState) => ({
          ...prevState,
          member_name: "",
        }));
      }
    }
    else if (name === "member_type") {
      const selectedId = value;
      setFormData((prevState) => ({
        ...prevState,
        [name]: selectedId,
      }));
      const selectedItem = sustanaibleGoals.find((goal) => goal.id === parseInt(selectedId));
      if (selectedItem) {
        setFormData((prevState) => ({
          ...prevState,
          member_type_display: selectedItem.sub_committee_names,
        }));
        setFormErrors((prevState) => ({
          ...prevState,
          member_type: "",
        }));
      } else {
        setFormErrors((prevState) => ({
          ...prevState,
          member_type: "Sustainable Goal is required.",
        }));
      }
    }
    else if (name === "committee_type") {
      const selectedId = value;
      const selectedCommittee = committeeNames.find(
        (committee) => String(committee.committee_id) === String(selectedId)
      );
      fetchcommitteeid(selectedId);
      const committeeName = selectedCommittee ? selectedCommittee.committee_name : "";
      setFormData((prevState) => ({
        ...prevState,
        [name]: selectedId,
        committee_type_name: committeeName,
      }));
      setFormErrors((prevState) => ({
        ...prevState,
        committee_type: "",
      }));
      setOthersInput(selectedId === "Any other Committee");
    }
    else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };
  const handleEdit = (index) => {
    const selectedData = filteredData[index];
    setEditData(selectedData);
    setOthersInput(selectedData.committee_type === "Any other Committee");
    setOpenEditModal(true);
  };
  const handleEditChange = (event) => {
    const { name, value } = event.target;
    const updatedValue =
      name === "mobile_no"
        ? value.replace(/\D/g, "").slice(0, 10)
        : name === "member_name"
          ? value.toUpperCase().replace(/[^A-Z\s]/g, "")
          : value;

    setEditData((prevState) => ({
      ...prevState,
      [name]: updatedValue,
    }));
    if (name === "committee_type") {
      setOthersInput(value === "Any other Committee");
    }
    setErrors((prevState) => ({
      ...prevState,
      [name]: name === "mobile_no" ? validateMobileNo(updatedValue) : "",
    }));
  };
  const handleDisableButton = async (is_active, ID) => {
    console.log(is_active, ID);
    if (is_active == 0) {
      is_active = 1;
    } else if (is_active == 1) {
      is_active = 0;
    }
    const data = {
      id: ID,
      is_active: is_active,
    };
    const res = await disableCommitteMember(token, data);
    if (res.status == "success") {
      toast.success("Updated successfully", { autoClose: 1000 });
      window.location.reload();
    } else {
      toast.error("An error occurred while updating the item.", { autoClose: 1000 });
    }
  };
  const handleReset = () => {
    setTableData([])
    setShowTable(true);
    setFormData({
      id: userId,
      committee_type: "",
      committeName: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
    setFormErrors({
      committee_type: "",
      member_type: "",
      member_name: "",
      mobile_no: "",
    });
  };
  const handleDelete = (index) => {
    setDeleteIndex(index);
    setOpenDialog(true);
  };
  const handleConfirmDelete = async () => {
    if (deleteIndex !== null) {
      try {
        const idToDelete = filteredData[deleteIndex].id;
        await deleteCommitteMember(token, idToDelete);
        setFilteredData(filteredData.filter((_, i) => i !== deleteIndex));
        toast.success("Deleted successfully");
      } catch (error) {
        console.error("Error deleting item:", error);
        toast.error("An error occurred while deleting the item.");
      }
    }
    setOpenDialog(false);
  };
  const handleToggleActive = async (index) => {
    const updatedData = filteredData.map((row, i) =>
      i === index ? { ...row, is_active: row.is_active === 1 ? 0 : 1 } : row
    );
    setFilteredData(updatedData);
    try {
      const res = await disableCommitteMember(token, { id: filteredData[index].id, is_active: updatedData[index].is_active });
      if (res.status === "success") {
        toast.success("Updated successfully");
      } else {
        toast.error("An error occurred while updating the item.");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("An error occurred while updating the item.");
    }
  };
  const handleCancelDelete = () => {
    setOpenDialog(false);

  };
  const handleComitteeChange = (e) => {
    console.log(e.target.value);
    formData.committee_type = e.target.value
  };
  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid" style={{
        height: "95vh",
        backgroundColor: "ffffff",
        padding: "20px",
        marginTop: "-17px",
      }}>
        <div className="ms-2" style={{ height: "90vh" }}>
          <div
            style={{
              backgroundColor: '#fffff',
              padding: '16px',
              marginTop: "-32px",
              marginLeft: '-32px',
              marginRight: '-32px',
              paddingLeft: '48px',
              paddingRight: '48px',
            }}
          >
            <h2
              className="pt-10"
              style={{
                top: "0",
                left: "0",
                margin: "16px",
                fontWeight: "bold",
              }}
            >
              Committee Members Details
            </h2>
          </div>


          <div style={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "20px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            margin: "16px"
          }}>
            <form className="row g-3 p-3" onSubmit={handleSubmit}>
              <div className="col-md-4">
                <label htmlFor="committee_type" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Committees Name <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.committee_type ? "is-invalid" : ""}`}
                  name="committee_type"
                  id="committee_type"
                  value={formData.committee_type}
                  onChange={handleChange}
                >
                  <option value="" disabled>Select Committee Name</option>
                  {committeeNames.map((committee) => (
                    <option key={committee.committee_id} value={committee.committee_id}>
                      {committee.committee_name}
                    </option>
                  ))}
                </select>

                {formErrors.committee_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.committee_type}
                  </p>
                )}
              </div>

              {othersInput && (
                <div className="col-md-4">
                  <label
                    htmlFor="committee-type"
                    className="form-label"
                    style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                  >
                    Committees Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    name="committeName"
                    className="form-control"
                    placeholder="Enter Committee Name"
                    onChange={(e) => handleComitteeChange(e)}
                  />
                </div>
              )}
              <div className="col-md-4">
                <label htmlFor="member_type" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Sustainable Goal <span style={{ color: "red", fontWeight: "800" }}>*</span>
                </label>
                <select
                  className={`form-select ${formErrors.member_type ? "is-invalid" : ""}`}
                  name="member_type"
                  id="member_type"
                  value={formData.member_type}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    handleChange({
                      target: {
                        name: "member_type",
                        value: selectedId,
                      },
                    });
                    const selectedItem = sustanaibleGoals.find((goal) => goal.id === parseInt(selectedId));
                    if (selectedItem) {
                      handleChange({
                        target: {
                          name: "member_type_display",
                          value: selectedItem.sub_committee_names,
                        },
                      });
                    }
                  }}
                >
                  <option value="" disabled>Select Sustainable Goal</option>
                  {sustanaibleGoals?.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.sub_committee_names}
                    </option>
                  ))}
                </select>
                {formErrors.member_type && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.member_type}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label htmlFor="member_name" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Member Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.member_name ? "is-invalid" : ""}`}
                  name="member_name"
                  id="member_name"
                  value={formData.member_name}
                  onChange={handleChange}
                  placeholder="Enter the Member Name"
                />
                {formErrors.member_name && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.member_name}
                  </p>
                )}
              </div>
              <div className="col-md-4">
                <label htmlFor="mobile_no" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                  Mobile No <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${formErrors.mobile_no ? "is-invalid" : ""}`}
                  name="mobile_no"
                  id="mobile_no"
                  value={formData.mobile_no}
                  onChange={handleChange}
                  placeholder="Enter the Mobile No"
                />
                {formErrors.mobile_no && (
                  <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                    {formErrors.mobile_no}
                  </p>
                )}
              </div>
              <div className="d-flex justify-content-end">
                <div className="col-md-2 row mt-2">
                  <Button
                    variant="contained"
                    onClick={handleAdd} sx={{
                      width: "70%",
                      backgroundColor: "#4763E430",
                      color: "#4763E4",
                      "&:hover": {
                        backgroundColor: "#4763E4",
                        color: "#fff"
                      },
                    }}
                  >
                    Add
                  </Button>
                </div>
              </div>

              {showTable && (
                <>
                  <div className="p-0" style={{ overflowX: 'auto', maxHeight: '44vh', marginTop: '20px' }}>
                    <Table aria-label="simple table">
                      <TableHead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          backgroundColor: "#d0ecf7",
                        }}
                      >
                        <TableRow>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            SR NO.
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            COMMITTEES NAME
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            SUSTAINABLE GOAL
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            MEMBER NAME
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            MOBILE NO.
                          </TableCell>
                          <TableCell style={{ whiteSpace: "nowrap", fontWeight: "bold" }} align="center">
                            ACTION
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableData.map((item, index) => (
                          <TableRow key={index}>
                            <TableCell align="center">{index + 1}</TableCell>
                            <TableCell align="center">{item.committee_type}</TableCell>
                            <TableCell align="center">{item.member_type}</TableCell>
                            <TableCell align="center">{item.member_name}</TableCell>
                            <TableCell align="center">{item.mobile_no}</TableCell>
                            <TableCell align="center" style={{ width: '100px' }}>
                              <Tooltip title="Delete" arrow>
                                <IconButton
                                  onClick={() => handleDelete_New(index)}
                                  sx={{
                                    color: '#e53935', // Red icon color for delete
                                    backgroundColor: 'transparent', // No background color
                                    '&:hover': {
                                      backgroundColor: 'transparent', // No background change on hover
                                      boxShadow: '0 4px 10px black', // Subtle shadow effect on hover
                                    },
                                    transition: 'box-shadow 0.3s', // Smooth transition for shadow only
                                    boxShadow: 'none', // No default shadow
                                    padding: '0px', // No extra padding for clean look
                                  }}
                                >
                                  <DeleteIcon sx={{ fontSize: '24px' }} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>

                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="col-md-2 row mt-2">
                      <Button
                        variant="contained"
                        onClick={handleReset}
                        sx={{
                          width: "70%",
                          backgroundColor: "#4763E430",
                          color: "#4763E4",
                          "&:hover": {
                            backgroundColor: "#4763E4",
                            color: "#fff"
                          },
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                    <div className="col-md-2 row mt-2">
                      <Button
                        variant="contained"
                        type="submit"
                        sx={{
                          width: "70%",
                          backgroundColor: "#4763E430",
                          color: "#4763E4",
                          "&:hover": {
                            backgroundColor: "#4763E4",
                            color: "#fff"
                          },
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </form>
            <Dialog
              open={openEditModal}
              onClose={() => setOpenEditModal(false)}
              maxWidth="lg"
              fullWidth
            >
              <DialogTitle style={{ fontWeight: "bold" }}>
                Edit Record
                <IconButton
                  edge="end"
                  color="inherit"
                  onClick={() => setOpenEditModal(false)}
                  aria-label="close"
                  style={{ position: "absolute", right: 15, top: 7 }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent>
                <form onSubmit={handleEditSubmit}>
                  <div className="row g-3">
                    <div className="col-md-4">
                      <label htmlFor="editCommitteeType" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                        Committees Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-select ${errors.committee_type ? "is-invalid" : ""}`}
                        name="committee_type"
                        id="editCommitteeType"
                        value={editData?.committee_type || ""}
                        onChange={handleEditChange}
                      >
                        <option value="" disabled>Select Committee Name</option>
                        {committeeNames?.map((committee) => (
                          <option key={committee.committee_id} value={committee.committee_id}>
                            {committee.committee_name}
                          </option>
                        ))}
                      </select>
                      {errors.committee_type && (
                        <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                          {errors.committee_type}
                        </p>
                      )}
                    </div>
                    {othersInput && (
                      <div className="col-md-4">
                        <label
                          htmlFor="editCommitteeName"
                          className="form-label"
                          style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                        >
                          Committees Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          name="committeeName"
                          className={`form-control ${errors.committeeName ? "is-invalid" : ""}`}
                          placeholder="Enter Committee Name"
                          value={editData?.committeeName || ""}
                          onChange={handleEditChange}
                        />
                        {errors.committeeName && (
                          <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                            {errors.committeeName}
                          </p>
                        )}
                      </div>
                    )}
                    <div className="col-md-4">
                      <label htmlFor="editMemberType" className="form-label" style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                        Sustainable Goal <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        className={`form-select ${errors.member_type ? "is-invalid" : ""}`}
                        name="member_type"
                        id="editMemberType"
                        value={editData?.member_type || ""}
                        onChange={handleEditChange}
                      >
                        <option value="" disabled>Select Sustainable Goal</option>
                        {memberType?.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                      </select>
                      {errors.member_type && (
                        <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                          {errors.member_type}
                        </p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label
                        htmlFor="editMemberName"
                        className="form-label"
                        style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                      >
                        Member Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.member_name ? "is-invalid" : ""}`}
                        name="member_name"
                        id="editMemberName"
                        value={editData?.member_name || ""}
                        onChange={handleEditChange}
                        placeholder="Enter the Member Name"
                      />
                      {errors.member_name && (
                        <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                          {errors.member_name}
                        </p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label
                        htmlFor="editMobileNo"
                        className="form-label"
                        style={{ fontSize: "0.9rem", fontWeight: "bold" }}
                      >
                        Mobile No <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`form-control ${errors.mobile_no ? "is-invalid" : ""}`}
                        name="mobile_no"
                        id="editMobileNo"
                        value={editData?.mobile_no || ""}
                        onChange={handleEditChange}
                        placeholder="Enter the Mobile No"
                      />
                      {errors.mobile_no && (
                        <p style={{ color: "red", fontSize: "10px", marginTop: "0.3rem" }}>
                          {errors.mobile_no}
                        </p>
                      )}
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        variant="contained"
                        onClick={() => setOpenEditModal(false)}
                        style={{
                          marginRight: "10px",
                          backgroundColor: "#323576",
                          color: "#ffffff",
                          width: "12%",
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        type="submit"
                        style={{
                          backgroundColor: "#323576",
                          color: "#ffffff",
                          width: "12%",
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                </form>
              </DialogContent>
            </Dialog>
            <Dialog open={openDialog} onClose={handleCancelDelete}>
              <DialogTitle>
                <AlertIcon style={{ color: "red", marginRight: "8px" }} />
                Confirm Delete
              </DialogTitle>
              <DialogContent>
                Are you sure you want to delete this record?
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCancelDelete} color="primary">
                  Cancel
                </Button>
                <Button color="secondary" onClick={handleConfirmDelete}>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
            <ToastContainer />
          </div>
        </div >
      </div>
    </>
  );
};
export default CommitteeMembersDetails;
